export interface Priority {
  icon?: string;
  color?: string;
  name?: string;
  value?: number;
}
